/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
    Blockly.Arduino.actuator = {};

    /**
     *
     * @param {*} hexadecimal
     * @returns
     */
    function hexToRed(hexadecimal) {
      return parseInt(cutHex(hexadecimal).substring(0, 2), 16);

    }

    /**
     *
     * @param {*} hexadecimal
     * @returns
     */
    function hexToGreen(hexadecimal) {
        return parseInt(cutHex(hexadecimal).substring(2, 4), 16);
    }

    /**
     *
     *
     * @param {*} hexadecimal
     * @return {*}
     */
    function hexToBlue(hexadecimal) {
        return parseInt(cutHex(hexadecimal).substring(4, 6), 16);
    }

    /**
     *
     *
     * @param {*} hexadecimal
     * @return {*}
     */
    function cutHex(hexadecimal) {
        return "#" == hexadecimal.charAt(1) ? hexadecimal.substring(2, 8) : hexadecimal;
    }

    /**
     *
     * @param {*} pin_red
     * @param {*} pin_green
     * @param {*} pin_blue
     * @param {*} red
     * @param {*} green
     * @param {*} blue
     * @param {*} rgb_type
     * @return {*}
     */
    function rgbToCode(pin_red, pin_green, pin_blue, red, green, blue, rgb_type) {
        // Pin modes
        Blockly.Arduino.setups_["setup_output_" + pin_red] = "pinMode(" + pin_red + ", OUTPUT);";
        Blockly.Arduino.setups_["setup_output_" + pin_green] = "pinMode(" + pin_green + ", OUTPUT);";
        Blockly.Arduino.setups_["setup_output_" + pin_blue] = "pinMode(" + pin_blue + ", OUTPUT);";

        if (rgb_type == "CC") {
            return (
                "// RGB write in each pin CC\n" +
                ("analogWrite(" + pin_red + "," + red + ");\n") +
                ("analogWrite(" + pin_green + "," + green + ");\n") +
                ("analogWrite(" + pin_blue + "," + blue + ");\n")
            );
        } else {
            return (
                "// RGB write in each pin CA\n" +
                ("analogWrite(" + pin_red + ", 255 - " + red + ");\n") +
                ("analogWrite(" + pin_green + ", 255 - " + green + ");\n") +
                ("analogWrite(" + pin_blue + ", 255 - " + blue + ");\n")
            );
        }
    }
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led = function() {
        // Get the selected values
        const pin = this.getFieldValue("PIN");
        const state = this.getFieldValue("STAT");

        // Configure pins
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        // Return comment + function
        return "// Led digital write function\n" + ("digitalWrite(" + pin + "," + state + ");\n");
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_lite = function() {
        // Get the selected values
        const pin = this.getFieldValue("PIN");
        const state = this.getFieldValue("STAT");

        // Configure pins
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        // Return comment + function
        return "// Led digital write function\n" + ("digitalWrite(" + pin + "," + state + ");\n");
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_pwm = function() {
        // Get the selected values
        const pin = this.getFieldValue("PIN");
        const value = Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC);
        // Configure the pin in setup function
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        return "analogWrite(" + pin + "," + value + ");\n";
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_pwm_lite = function() {
        // Get the selected values
        const pin = this.getFieldValue("PIN");
        const value = Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC);
        // Configure the pin in setup function
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        return "analogWrite(" + pin + "," + value + ");\n";
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_rgb_color_picker = function() {
        // Get the pins
        const pin_red = this.getFieldValue("PIN_R");
        const pin_green = this.getFieldValue("PIN_G");
        const pin_blue = this.getFieldValue("PIN_B");
        // Get the color selected from color picker
        const color = Blockly.Arduino.valueToCode(this, "COLOUR", Blockly.Arduino.ORDER_ATOMIC);

        // Color -> HEX
        const red = hexToRed(color);
        const green = hexToGreen(color);
        const blue = hexToBlue(color);
        // Get the type common catode (CC), or common anode (CA)
        const rgb_type = this.getFieldValue("TYPE");
        // Generate the code
        return rgbToCode(pin_red, pin_green, pin_blue, red, green, blue, rgb_type);
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_rgb_color_picker_lite = function() {
        // Get the pins
        const pin_red = this.getFieldValue("PIN_R");
        const pin_green = this.getFieldValue("PIN_G");
        const pin_blue = this.getFieldValue("PIN_B");
        // Get the color selected from color picker
        const color = Blockly.Arduino.valueToCode(this, "COLOUR", Blockly.Arduino.ORDER_ATOMIC);

        // Color -> HEX
        const red = hexToRed(color);
        const green = hexToGreen(color);
        const blue = hexToBlue(color);
        // Get the type common catode (CC), or common anode (CA)
        const rgb_type = this.getFieldValue("TYPE");
        // Generate the code
        return rgbToCode(pin_red, pin_green, pin_blue, red, green, blue, rgb_type);
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_rgb = function() {
        // Get the pines
        const pin_red = this.getFieldValue("PIN_R");
        const pin_green = this.getFieldValue("PIN_G");
        const pin_blue = this.getFieldValue("PIN_B");
        // Get the colors selected
        const red = Blockly.Arduino.valueToCode(this, "R", Blockly.Arduino.ORDER_ATOMIC);
        const green = Blockly.Arduino.valueToCode(this, "G", Blockly.Arduino.ORDER_ATOMIC);
        const blue = Blockly.Arduino.valueToCode(this, "B", Blockly.Arduino.ORDER_ATOMIC);
        // Get the type common catode (CC), or common anode (CA)
        const rgb_type = this.getFieldValue("TYPE");
        // Generate the code
        return rgbToCode(pin_red, pin_green, pin_blue, red, green, blue, rgb_type);
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_led_rgb_lite = function() {
        // Get the pines
        const pin_red = this.getFieldValue("PIN_R");
        const pin_green = this.getFieldValue("PIN_G");
        const pin_blue = this.getFieldValue("PIN_B");
        // Get the colors selected
        const red = Blockly.Arduino.valueToCode(this, "R", Blockly.Arduino.ORDER_ATOMIC);
        const green = Blockly.Arduino.valueToCode(this, "G", Blockly.Arduino.ORDER_ATOMIC);
        const blue = Blockly.Arduino.valueToCode(this, "B", Blockly.Arduino.ORDER_ATOMIC);
        // Get the type common catode (CC), or common anode (CA)
        const rgb_type = this.getFieldValue("TYPE");
        // Generate the code
        return rgbToCode(pin_red, pin_green, pin_blue, red, green, blue, rgb_type);
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer = function() {
        Blockly.Arduino.definitions_.define_tone = '#include "TimerFreeTone.h"';
        const pin = this.getFieldValue("PIN");
        const tone = Blockly.Arduino.valueToCode(this, "TONE", Blockly.Arduino.ORDER_ATOMIC);
        const time_ms = Blockly.Arduino.valueToCode(this, "MS", Blockly.Arduino.ORDER_ATOMIC);

        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";

        return "TimerFreeTone(" + pin + "," + tone + "," + time_ms + ");\n";
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer_tone_lite = function() {
        Blockly.Arduino.definitions_.define_tone = '#include "TimerFreeTone.h"';
        const pin = this.getFieldValue("PIN");
        const tone = this.getFieldValue("NOTE");
        const time_ms = this.getFieldValue("S");

        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";

        return "TimerFreeTone(" + pin + "," + tone + "," + (time_ms * 1000) + ");\n";
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer_rttl = function() {
        Blockly.Arduino.definitions_.define_tone = '#include "TimerFreeTone.h"';

        const pin = this.getFieldValue("PIN");
        const rtttl = Blockly.Arduino.valueToCode(this, "RTTTL", Blockly.Arduino.ORDER_ATOMIC);
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        return "TimerFreeToneRtttl(" + pin + ",(const char *)" + rtttl + ".c_str());\n";
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer_tone = function() {
        return [this.getFieldValue("NOTE"), Blockly.Arduino.ORDER_ATOMIC];
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer_rttl_melody = function() {
        // Get the values selected from the user
        const rtttl_melody = this.getFieldValue("RTTTL_MELODY"),
            b = this.getField("RTTTL_MELODY");
        var c = '""';

        if (b) {
            for (var d = -1, e = b.getOptions(), f = 0; f < e.length; f++) e[f][1] == b.value_ && (d = f);
            0 <= d &&
                ((Blockly.Arduino.definitions_["var_rttl_melody_" + d] = "String rtt_melody_" + d + '="' + rtttl_melody + '";'),
                (c = "rtt_melody_" + d));
        }

        return [c, Blockly.Arduino.ORDER_ATOMIC];
    };
    /**************************************************************************************************************/
    Blockly.Arduino.actuator_buzzer_rttl_melody_lite = function() {
        Blockly.Arduino.definitions_.define_tone = '#include "TimerFreeTone.h"';

        // Get the values selected from the user
        const rtttl_melody = this.getFieldValue("RTTTL_MELODY"),
            b = this.getField("RTTTL_MELODY");
        var c = '""';

        if (b) {
            for (var d = -1, e = b.getOptions(), f = 0; f < e.length; f++) e[f][1] == b.value_ && (d = f);
            0 <= d &&
            ((Blockly.Arduino.definitions_["var_rttl_melody_" + d] = "String rtt_melody_" + d + '="' + rtttl_melody + '";'),
                (c = "rtt_melody_" + d));
        }

        const pin = this.getFieldValue("PIN");
        Blockly.Arduino.setups_["setup_output_" + pin] = "pinMode(" + pin + ", OUTPUT);";
        return "TimerFreeToneRtttl(" + pin + ",(const char *)" + c + ".c_str());\n";
    };

}
